/* src/app/dialogs/file-folder-editor/file-folder-editor.component.css */
.add-files-btn {
  float: right;
}
:host {
  height: 100%;
  display: flex;
  flex: 1;
  flex-direction: column;
}
.actions {
  justify-content: flex-end;
}
.container {
  height: 100%;
}
/*# sourceMappingURL=file-folder-editor.component-TSGWPNVH.css.map */
